export default {
    InlineImageLoad: {
        datapoint: {
            name: 'InlineImageLoad',
            customData: function (type, howLoad, error, context, loaderCode) { return [type, howLoad, error, context, loaderCode]; },
        },
    },
    // The reporting framework currently only aggregates first 4 custom data. Custom data beyond 4 requires running ad hoc query
    // directly against cosmos. To make most use of it, I'm putting the first 4 custom data as: error, type, howLoad, statusCode
    InlineImageLoadError: {
        datapoint: {
            name: 'InlineImageLoadError',
            customData: function (type, howLoad, error, statusCode, context, loaderCode, originalSrc, contentType, field1, field2, field3, field4, field5) { return [
                type,
                howLoad,
                error,
                statusCode,
                context,
                loaderCode,
                originalSrc,
                contentType,
                field1,
                field2,
                field3,
                field4,
                field5,
            ]; },
        },
    },
    ImageUploading: {
        datapoint: {
            name: 'InlineImageAttachmentUpload',
            customData: function (fileType) { return [fileType]; },
        },
    },
    CreateDataURIMissingNaturalDimensions: {
        datapoint: {
            name: 'CreateDataURIMissingNaturalDimensions',
        },
    },
    ImageCopyHandlerNullDataURI: {
        datapoint: {
            name: 'ImageCopyHandlerNullDataURI',
        },
    },
};
//# sourceMappingURL=datapoints.js.map